import { CSSObject } from '@emotion/css';
import mergeDeep from '@/utils/merge-deep';

/**
 * Function has two goals:
 * - Solution to have a better dx experience outside emotion functions: enable Intellisense (typescript) and lint (stylelint) inside object styles
 * - Deep merge different styles (objects, placeholders, mixins)
 * @param {CSSObject} args -object styles
 *
 * Example:
 * cssObj({ color: 'blue';}, resetFirstLastMargins)
 */

export const cssObj = (...args: CSSObject[]) => mergeDeep({}, ...args);
